<template>
    <div class="flex justify-center w-full">
        <div class="flex flex-col w-1/3 items-center">
            <!-- Contents -->


        </div>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';

export default {
    name: "IsoProbeCalibrationMain",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {},
    emits: [],
    props: {
        // Props
        probeCalibration: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            // Data Properties
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        // Methods
    },
    computed: {},
    watch: {},
}
</script>

<style scoped>

</style>